import React from "react";
import PropTypes from "prop-types";

const Flex = ({
  className,
  container,
  justifyContent,
  flexDirection,
  flexGrow,
  flexBasis,
  flexShrink,
  flexWrap,
  flex,
  alignItems,
  margin,
  padding,
  width,
  height,
  maxWidth,
  children,
  style,
}) => (
  <div
    className={className}
    style={{
      display: container ? "flex" : "block",
      justifyContent: justifyContent,
      flexDirection: flexDirection,
      flexGrow: flexGrow,
      flexBasis: flexBasis,
      flexShrink: flexShrink,
      flexWrap: flexWrap,
      flex: flex,
      alignItems: alignItems,
      margin: margin,
      padding: padding,
      width: width,
      height: height,
      maxWidth: maxWidth,
      ...style,
    }}
  >
    {children}
  </div>
);

export default Flex;

Flex.defaultProps = {
  justifyContent: "flex-start",
  flexDirection: "row",
  flexGrow: 0,
  flexBasis: "auto",
  flexShrink: 1,
  flexWrap: "nowrap",
  flex: "0 1 auto",
  alignItems: "stretch",
  margin: 0,
  padding: 0,
  width: "auto",
  height: "auto",
  maxWidth: "none",
};

Flex.propTypes = {
  justifyContent: PropTypes.string,
  flexDirection: PropTypes.string,
  flexGrow: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flexBasis: PropTypes.string,
  flexShrink: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flexWrap: PropTypes.string,
  flex: PropTypes.string,
  alignItems: PropTypes.string,
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.string,
  height: PropTypes.string,
  maxWidth: PropTypes.string,
  style: PropTypes.object,
};
